import { render, staticRenderFns } from "./TeamGamesProvider.vue?vue&type=template&id=868c7a96&"
import script from "./TeamGamesProvider.vue?vue&type=script&lang=ts&"
export * from "./TeamGamesProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports